import { useState, useCallback } from 'react';

export type ToastType = "success" | "error";

interface ToastState {
  message: string | null;
  type: ToastType;
}

/**
 * トースト通知管理用カスタムフック
 * - 成功/エラーメッセージの表示
 * - 自動非表示タイマー
 * - メッセージタイプの管理
 */
export const useToastNotification = () => {
  const [toastState, setToastState] = useState<ToastState>({
    message: null,
    type: "success"
  });

  const showToast = useCallback((message: string, type: ToastType = "success") => {
    setToastState({
      message,
      type
    });
    
    // 3秒後に自動で非表示
    setTimeout(() => {
      setToastState(prev => ({ ...prev, message: null }));
    }, 3000);
  }, []);

  const hideToast = useCallback(() => {
    setToastState(prev => ({ ...prev, message: null }));
  }, []);

  return {
    toastMessage: toastState.message,
    toastType: toastState.type,
    showToast,
    hideToast
  };
};

export default useToastNotification;